import React, {useEffect, useRef, useState} from "react";
import styles from "./Timepicker.module.scss";
import JalaliMoment from "jalali-moment";

const Timepicker = ({ onTimeChanged, value, themeColor, amOrPm }) => {

  const [showPicker, setShowPicker] = useState(false);
  const [editMode, setEditMode] = useState(true);
  const [activeHour, setActiveHour] = useState(0);
  const [activeMinute, setActiveMinute] = useState(0);
  const [hoursMargin, setHoursMargin] = useState((activeHour) * -24);
  const [minutesMargin, setMinutesMargin] = useState((activeMinute) * -24);
  const [chooseAmOrPm, setChooseAmOrPm] = useState("AM");

  useEffect(() => {
    if (amOrPm) {
      setChooseAmOrPm(amOrPm)
    }
  }, [amOrPm])

  const hourInputRef = useRef(null);
  const minuteInputRef = useRef(null);

  const handleTriggerShowPicker = (status) => {

    const handleSetData = (param) => {
      switch (param) {
        case "show":
          setActiveHour(value.hour ? Number(JalaliMoment(`${value.hour}:${value.minute}`, ["HH:mm"]).format("hh")) : 1);
          setActiveMinute(value.minute || 1);
          setShowPicker(true);
          break;
        case "hide":
          setActiveHour(0);
          setActiveMinute(0);
          onTimeChanged({ hour: 0, minute: 0 });
          setShowPicker(false);
          break;
        default:
          break;
      }
    }

    if (status) {
      handleSetData(status);
    } else {
      if (!showPicker) {
        handleSetData("show");
      } else {
        handleSetData("hide");
      }
    }

  }

  useEffect(() => {
    if (value.hour !== 0 || value.minute !== 0) {
      handleTriggerShowPicker("show");
    }
  }, [value])

  let mapParams = {
    activeHour: activeHour,
    activeMinute: activeMinute
  }
  let margins = {
    activeHour: hoursMargin,
    activeMinute: minutesMargin
  }

  const handleScroll = (e, param) => {
    let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
    let maxNums = 12;
    if (param === "activeMinute") {
      maxNums = 59;
    }

    if (delta > 0 && mapParams[param] - 1 >= 1) {
      margins[param] = margins[param] + 24;
      mapParams[param] = mapParams[param] - 1;
      if (param === "activeHour") {
        setActiveHour(mapParams[param]);
      } else {
        setActiveMinute(mapParams[param]);
      }
    } else if (delta < 0 && mapParams[param] + 1 <= maxNums) {
      margins[param] = margins[param] - 24;
      mapParams[param] = mapParams[param] + 1;
      if (param === "activeHour") {
        setActiveHour(mapParams[param]);
      } else {
        setActiveMinute(mapParams[param]);
      }
    }
    if (param === "activeHour") {
      setHoursMargin(margins[param]);
    } else {
      setMinutesMargin(margins[param]);
    }
  }

  useEffect(() => {
    if (showPicker) {
      const hours = document.getElementById("hours");
      const minutes = document.getElementById("minutes");
      hours.addEventListener('wheel', (e) => {
        handleScroll(e, 'activeHour');
      });
      minutes.addEventListener('wheel', (e) => {
        handleScroll(e, 'activeMinute');
      });
    }
  }, [showPicker]);

  const hours = () => {
    let hours = [];
    let i = 1;
    while (i <= 12) {
      hours.push(('0' + i++).slice(-2));
    }
    return hours;
  }

  const minutes = () => {
    let minutes = [];
    let i = 1;
    while (i <= 59) {
      minutes.push(('0' + i++).slice(-2));
    }
    return minutes;
  }

  useEffect(() => {
    if (activeHour !== 0 && activeMinute !== 0) {
      onTimeChanged({hour: activeHour, minute: activeMinute, modifier: chooseAmOrPm});
    }
  }, [activeHour, activeMinute, chooseAmOrPm]);

  const pickerInput = () => {

    const zIndex = editMode ? 0 : -1;

    const handleChangeHourInput = (e, type, min = 1, max = 12) => {
      const value = ('0' + e.target.value).slice(-2);
      const regex = /^[0-9\b]+$/;
      if (value === '' || ((regex.test(value)) && (value <= max && value >= min))) {
        if (type === "hour") {
          setHoursMargin((value - 1) * -24);
          setActiveHour(value);
        } else {
          setMinutesMargin((value - 1) * -24);
          setActiveMinute(value);
        }
      } else {
        if (type === "hour") {
          setActiveHour('');
        } else {
          setActiveMinute('');
        }
      }
    }

    return (
      <>
        <div className={`${styles.mainPicker} d-flex align-items-center`}>
          <div id={"hours"} className={`${styles.pickerInput} d-flex align-items-center justify-content-center`}>
            <div>
              <div style={{marginTop: hoursMargin}}>
                {
                  hours().map(hour => <div className={`${styles.num} ${activeHour == hour && styles.active}`}>{ hour }</div>)
                }
              </div>
            </div>
            <input autoComplete={"off"} onChange={(e) => handleChangeHourInput(e, 'hour', 1, 12)} ref={hourInputRef} value={activeHour == '' ? '' : ('0' + activeHour).slice(-2)} type={"text"} style={{zIndex}} />
          </div>:
          <div id={"minutes"} className={`${styles.pickerInput} d-flex align-items-center justify-content-center`}>
            <div>
              <div style={{marginTop: minutesMargin}}>
                {
                  minutes().map(minute => <div className={`${styles.num} ${activeMinute == minute && styles.active}`}>{ minute }</div>)
                }
              </div>
            </div>
            <input autoComplete={"off"} onChange={(e) => handleChangeHourInput(e, 'minute', 1, 59)} ref={minuteInputRef} value={activeMinute == '' ? '' : ('0' + activeMinute).slice(-2)} type={"text"} style={{zIndex}} />
          </div>
        </div>
        <div className={styles.amOrPm}>
          <div style={{color: themeColor}} className={chooseAmOrPm === "AM" && styles.active} onClick={() => setChooseAmOrPm("AM")}>
            AM
          </div>
          <div style={{color: themeColor}} className={chooseAmOrPm === "PM" && styles.active} onClick={() => setChooseAmOrPm("PM")}>
            PM
          </div>
        </div>
      </>
    )
  }

  return (

    <div>
      <div className={`${styles.Timepicker} d-flex align-items-center justify-content-between`}>
        <div className={"d-flex align-items-between justify-content-center"}>
          Time
          {
            showPicker && (
              pickerInput()
            )
          }
        </div>
        {
          <div onClick={() => handleTriggerShowPicker()} className={"d-flex align-items-between justify-content-center"}>
            {
              showPicker ? (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.9963 7.99561L8.00293 11.9889" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11.9974 11.9914L8.00073 7.9939" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.612 2.29175H6.38783C3.87033 2.29175 2.29199 4.07425 2.29199 6.59675V13.4034C2.29199 15.9259 3.86283 17.7084 6.38783 17.7084H13.6112C16.137 17.7084 17.7087 15.9259 17.7087 13.4034V6.59675C17.7087 4.07425 16.137 2.29175 13.612 2.29175Z" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.0001 6.93945V13.0447" stroke="#200E32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13.0557 9.99215H6.94458" stroke="#200E32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9048 1.66675H6.09532C3.3731 1.66675 1.66675 3.59348 1.66675 6.32105V13.6791C1.66675 16.4067 3.36516 18.3334 6.09532 18.3334H13.9048C16.635 18.3334 18.3334 16.4067 18.3334 13.6791V6.32105C18.3334 3.59348 16.635 1.66675 13.9048 1.66675Z" stroke="#200E32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                )
            }
          </div>
        }
      </div>
    </div>
  )
}

export default Timepicker;